import { RootState } from '@/store';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sortByReleaseAtSelector } from '@/store/selectors/domain/archive';
import { GroupedArchive } from '@/store/selectors/domain/archive';
import type { ResolvedData as ResolvedPagingData } from '@/app/archives/archivesGetByPaging';
import archivesGetByPaging from '@/app/archives/archivesGetByPaging';
import archivesGetAll, {
  ResolvedArchiveData,
} from '@/app/archives/archivesGetAll';
import { Dispatch } from 'redux';
import {
  archivesInitialLoadSucceeded,
  archivesLoadSucceeded,
} from '@/store/ducks/domain/archives';

async function paging(scrollId: string, dispatch: Dispatch) {
  const data = await archivesGetByPaging({
    scrollId,
  });
  dispatch(archivesLoadSucceeded(data));
}

export const useArchive = () => {
  const groupedArchives: GroupedArchive = useSelector<
    RootState,
    GroupedArchive
  >(sortByReleaseAtSelector);

  const dispatch = useDispatch();

  const fetchArchiveAsync = useCallback(async () => {
    const data = await archivesGetAll();
    dispatch(archivesInitialLoadSucceeded(data));
  }, [dispatch]);

  // apiからのデータを処理してarchiveに追加

  const importArchiveData = useCallback(
    (data: any, shouldReplace?: boolean) => {
      if (shouldReplace) {
        dispatch(archivesInitialLoadSucceeded(data));
      } else {
        dispatch(archivesLoadSucceeded(data));
      }
    },
    [dispatch]
  );

  return {
    fetchArchiveAsync,
    groupedArchives,
    importArchiveData,
    paging,
  };
};
